import * as z from "zod";

export const getPostscriptIntegration = {
  name: "getPostscriptIntegration" as const,
  input: z.null(),
  output: z.object({
    exists: z.boolean(),
    orderTrackingEnabled: z.boolean(),
    privateApiKey: z.string().optional(),
    webhooksEvents: z.array(
      z.union([
        z.literal("shop.incoming_message"),
        z.literal("shop.email_collected"),
      ]),
    ),
  }),
};
